export const LINK_COLOR = '#0056b3'
